import {scenarioTriggers} from "./scenarioTriggers";

export const triggerLabels = {
    [scenarioTriggers.allAlarmTypes]: 'trigger.allAlarmTypes',
    [scenarioTriggers.genericAlarm]: 'genericAlarm',
    [scenarioTriggers.manDown]: 'manDown',
    [scenarioTriggers.sosButton]: 'sosButton',
    [scenarioTriggers.ripcord]: 'ripcord',
    [scenarioTriggers.timer]: 'timer',
    [scenarioTriggers.alarmClosed]: 'alarmClosed',
    [scenarioTriggers.assistanceRequestClosed]: 'assistanceRequestClosed',
    [scenarioTriggers.connectionChanged]: 'connectionChange',
    [scenarioTriggers.quickButton]: 'quickButton',
    [scenarioTriggers.beaconBattery]: 'trigger.beaconBattery',
    [scenarioTriggers.geofenceEntered]: 'enterGeofence',
    [scenarioTriggers.geofenceExited]: 'exitGeofence',
    [scenarioTriggers.geofenceAttendance]: 'trigger.geofenceAttendance',
    [scenarioTriggers.docked]: 'docked',
    [scenarioTriggers.undocked]: 'undocked',
    [scenarioTriggers.lowBattery]: 'lowBattery',
    [scenarioTriggers.smsMessage]: 'smsMessage',
    [scenarioTriggers.webhook]: 'webhook',
    [scenarioTriggers.ioChange]: 'ioChange',
    [scenarioTriggers.email]: 'emailMessage',
    [scenarioTriggers.espa]: 'espaEvent',
    [scenarioTriggers.multiTenant]: 'multiTenant',
    [scenarioTriggers.configError]: 'configError',
    [scenarioTriggers.messageNotAcknowledged]: 'messageNotAcknowledged',
    [scenarioTriggers.checkAssistanceRequestResponses]: 'checkAssistanceRequestResponses',
    [scenarioTriggers.arcAlarm]: 'arcAlarm',
    [scenarioTriggers.scenarioDisabled]: 'scenarioDisabled',
    [scenarioTriggers.appIdle]: 'appIdle',
    [scenarioTriggers.schedule]: 'schedule',
    [scenarioTriggers.beaconAge]: 'scenarioTrigger.beaconAge',
    [scenarioTriggers.appPermissionsIncorrect]: 'appPermissionsIncorrect',
    [scenarioTriggers.noAlarmInPeriod]: 'trigger.noAlarmInPeriod',
    [scenarioTriggers.noBeaconInPeriod]: 'trigger.noBeaconInPeriod'
};
